import actionCreatorFactory from 'typescript-fsa';
import { SourceCategory } from '../Entities/Stories/stories.reducer';
import { CategoryMap } from './copy-stream-categories.reducer';
const actionCreator = actionCreatorFactory('CopyStreamCategories');

export const fetchProductCount = actionCreator<{
  categories: SourceCategory[];
}>('COPY_STREAM_FETCH_PRODUCT_COUNT');

interface ProductCountPayload {
  categoryId: number;
  productCount: number;
}

export const updateProductCount = actionCreator<ProductCountPayload>(
  'COPY_STREAM_UPDATE_PRODUCT_COUNT'
);
export const fetchCategoryMap = actionCreator<{ categories: SourceCategory[] }>(
  'COPY_STREAM_FETCH_CATEGORY_MAP'
);

export interface CategoryMapPayload {
  categoryMap: CategoryMap;
}
export const updateCategoryMap = actionCreator<CategoryMapPayload>(
  'COPY_STREAM_UPDATE_CATEGORY_MAP'
);



// WEBPACK FOOTER //
// ./src/store/CopyStreamCategories/copy-stream-categories.actions.ts